<template>
  <DialogModal v-if="isOpen" @close="$emit('cancel')">
    <template #title>Confirm Deletion</template>
    <template #content>
      <p>Are you sure you want to delete the task: <span class="font-medium">{{ itemName }}</span>?</p>
      <p class="text-sm text-gray-500 mt-2">This action cannot be undone.</p>
    </template>
    <template #footer>
      <div class="flex justify-end space-x-3">
        <button 
          @click="$emit('cancel')" 
          class="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
        >
          Cancel
        </button>
        <button 
          @click="$emit('confirm')" 
          class="px-4 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700"
          :disabled="isDeleting"
        >
          <div class="flex items-center">
            <Loader2 v-if="isDeleting" class="w-4 h-4 mr-2 animate-spin" />
            <span>Delete</span>
          </div>
        </button>
      </div>
    </template>
  </DialogModal>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
import DialogModal from './DialogModal.vue'

defineProps<{
  isOpen: boolean
  itemName: string
  isDeleting: boolean
}>()

defineEmits(['confirm', 'cancel'])
</script> 